import React from 'react';
import { MapPin, Phone, Instagram, Facebook, Clock } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8" id="contact">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand Info */}
          <div>
            <h3 className="text-2xl font-bold font-serif mb-6">SOLARIA <span className="text-orange-500">MADIUN</span></h3>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Menyajikan hidangan lezat berkualitas dengan cita rasa otentik Indonesia dan Asia. Tempat terbaik untuk berkumpul bersama keluarga dan teman.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-purple-600 transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-blue-600 transition-colors">
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-bold mb-6 text-orange-500">Hubungi Kami</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-gray-300">
                <MapPin className="mt-1 text-purple-500 shrink-0" size={20} />
                <span>Jl. Pahlawan No. 123, Madiun, Jawa Timur (Lokasi Contoh)</span>
              </li>
              <li className="flex items-center gap-3 text-gray-300">
                <Phone className="text-purple-500 shrink-0" size={20} />
                <span>(0351) 1234567</span>
              </li>
              <li className="flex items-center gap-3 text-gray-300">
                <Clock className="text-purple-500 shrink-0" size={20} />
                <span>Setiap Hari: 10:00 - 22:00 WIB</span>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-6 text-orange-500">Tautan Cepat</h4>
            <ul className="space-y-3">
              {['Menu Utama', 'Promo Spesial', 'Lokasi Outlet', 'Karir', 'Tentang Kami'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2">
                    <span className="w-1.5 h-1.5 bg-purple-500 rounded-full"></span>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-500 text-sm">
          <p>&copy; {new Date().getFullYear()} Solaria Madiun. All rights reserved.</p>
          <p className="mt-2">Created with Youware.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
